import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../components/breadCrumb";
import CheckBox from "../components/common/CheckBox";
import { apiUserSettingsUpdate } from "../services/UsersService";
import PageContent from "../components/pageContent";
import { userSettingsAction } from "../redux/actions";
import { useState } from "react";
import Spinner from "../components/common/Spinner";

interface Props {
  contextLevel: string;
}

const NastaveniPage = (props: Props) => {

  const userInfo = useSelector((state: any) => state.userInfo);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  return (
    <>

      <PageContent>
        <div className="pageContainer">

          {loading && <Spinner loadingText="Loading" />}
          <CheckBox
            id="chkRememberFields"
            handleCheckedChange={async (checked) => {

              setLoading(true);
         
              let settingResponse = await apiUserSettingsUpdate({
                RememberFieldsValues: checked
              });

              dispatch(userSettingsAction(JSON.stringify({ rememberFieldsValues: checked })));

              setLoading(false);

              if (settingResponse.status !== 200){
                alert('Error');
              }
            }}
            label="Pamatovat si hodnoty výběrových polí?"
            defaultValue={userInfo.RememberFieldsValues}
          />
        </div>
      </PageContent>
    </>
  );
};

export default NastaveniPage;
